import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface ICancelWidgetProps {
    onClose: () => void;
}

export const CancelWidget = ({ onClose }: ICancelWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt; <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="How_do_I_cancel_an_order"
                        defaultMessage="Cancel Order"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-6">
                        <h3>
                            <FormattedMessage
                                id="Step_by_step_guide"
                                defaultMessage="Step by Step Guide"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="On_the_eStore_home_page"
                                    defaultMessage="Step 1. On the eStore home page, click on ‘My Orders’ under ‘Quick Links’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Search_for_the_order_to_cancel"
                                    defaultMessage="Step 2. Search for the order you would like to cancel and click on the order number or ‘See Details’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Next_under_make_changes_select_cancel"
                                    defaultMessage="Step 3. Next, under ‘Need to make changes to your order?’ select ‘Cancel Order’"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="A_pop_up_will_appear_cancellation_reason"
                                    defaultMessage="Step 4. A pop-up will appear asking for a reason for the cancellation, once you select ‘Continue’ and cancel the order it cannot be undone"
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="The_order_status_bar_will_update"
                                    defaultMessage="Step 5. The order status bar will update to a red and show ‘Cancelled’, the order will be removed from order history and you will receive a confirmation of the cancellation via email"
                                />
                            </li>
                        </ol>
                    </div>
                    <div className="col-sm-6">
                        <h3>
                            <FormattedMessage
                                id="Video_tutorial"
                                defaultMessage="Video Tutorial"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="How_to_cancel_an_order"
                                    defaultMessage="How to Cancel an order"
                                />
                                <iframe
                                    className="help-center-video"
                                    src="https://bcove.video/3gXyiSx"
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                    title="video"
                                />
                                <FormattedMessage
                                    id="Learn_how_to_cancel_an_order"
                                    defaultMessage="Learn how to cancel an order"
                                />
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const cancelWidgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CancelWidget);

export default cancelWidgetContainer;
